import axios from 'axios'
import router from './../../../router'

export const getToken = ({ commit }, user) => {
    return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(() => {
            axios
                .post("/api/login", user)
                .then((response) => {
                    localStorage.setItem("token", response.data.token);
                    if (response.data.role == "superadmin") {
                        router.push("/app/data-akun");
                    } else {
                        router.push("/app/dashboard"); //if sign in success push to dashboard
                    }
                    resolve(false);
                })
                .catch((errors) => {
                    reject(errors.response.data.errors);
                });
        }).catch(e => {

        });



    })
}

// export const getUser = ({ commit }, user) => {
//     axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
//     axios
//         .get("/api/user")
//         .then((response) => {
//             commit('SET_USER', response.data)
//         })
//         .catch((errors) => {
//             localStorage.removeItem("token");
//             router.push("/login");
//         })
// }

export const getUser = ({ commit, dispatch }, user) => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    return new Promise((resolve, reject) => {
        axios
            .get("/api/user")
            .then((response) => {
                commit('SET_USER', response.data)
                let status = {
                    loading: false,
                    oke: true
                }
                resolve(status)
            })
            .catch((errors) => {
                localStorage.removeItem("token");
                router.push("/login");
                if (errors.response.status == "500" || errors.response.status == "429") {
                    router.push("/server-error");
                }
                reject(errors.response.status);
            })
    })
}

// return new Promise((resolve, reject) => {
//     // Do something here... lets say, a http call using vue-resource
//     this.$http("/api/something").then(response => {
//         // http success, call the mutator and change something in state
//         resolve(response);  // Let the calling function know that http is done. You may send some data back
//     }, error => {
//         // http failed, let the calling function know that action did not work out
//         reject(error);
//     })
// })